import React from "react";
import PropTypes from "prop-types";
import { LoadingIndicator } from "@sainsburys-tech/fable";

const LoadingView = ({ message = "Loading" }) => (
  <LoadingIndicator isLoading scheme="light" label={message} isStandalone size="lg"/>
);

LoadingView.propTypes = {
  message: PropTypes.string
};

export default LoadingView;
